import { Table, TableBody, TableHead } from '@mui/material'
import { Fatness } from 'models/IFarm'
import CustomTableRow from 'ui/table/CustomTableRow'
import { TableHeader } from './components'
import { useGetCellOptions } from './hooks/useGetCellOptions'
interface FatnessWidgetTableProps {
	fatness?: Fatness[]
	totalCattle?: number
}
export const FatnessWidgetTable = ({
	fatness,
	totalCattle = 0,
}: FatnessWidgetTableProps) => {
	const TABLE_OPTIONS = useGetCellOptions({ fatness, totalCattle })
	return (
		<Table>
			<TableHead>
				<TableHeader />
			</TableHead>
			<TableBody>
				{TABLE_OPTIONS.map((option, index) => (
					<CustomTableRow
						key={index}
						rowKey={option.rowKey}
						cellItems={option.cellItems}
						rowHeight={option.rowHeight}
					/>
				))}
			</TableBody>
		</Table>
	)
}
